<template>
  <header class="navbar is-primary-mobile has-shadow">
    <div class="navbar-brand">
      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbar-menu"
        @click="toggleNavbarMenu"
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </a>
    </div>

    <div
      id="navbar-menu"
      class="navbar-menu"
      :class="navbarMenuIsActive"
    >
      <AppMenu class="navbar-start" />
      <div class="navbar-end">
        <a
          class="navbar-item is-flex is-centered link-navbar-sign-manifest"
          href="https://www.cfdi.com.mx/manifiesto"
          target="__blank"
        >
          Firmar manifiesto CONTPAQi
        </a>

        <div
          class="navbar-item has-dropdown is-hoverable"
          :class="{ 'is-active': activeMenus.includes('cfdis') }"
        >
          <a
            class="navbar-link is-arrowless link-navbar-cfdis"
          >
            <BIcon
              icon="bank"
              type="is-primary"
            />
            <span class="has-text-primary">CFDIs</span>
          </a>

          <div class="navbar-dropdown">
            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-new-invoice"
              :to="{ name: 'NewInvoice' }"
            >
              <BIcon
                icon="bank"
                type="is-primary"
              />
              <span class="has-text-primary">Factura</span>
            </RouterLink>

            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-new-auto-invoice"
              :to="{ name: 'NewAutoInvoice' }"
            >
              <BIcon
                icon="auto-fix"
                type="is-primary"
              />
              <span class="has-text-primary">Autofactura</span>
            </RouterLink>

            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-new-rep"
              :to="{ name: 'NewRep' }"
            >
              <BIcon
                icon="file-document-box-outline"
                type="is-primary"
              />
              <span class="has-text-primary">Complemento de Pago</span>
            </RouterLink>

            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-new-credit-note"
              :to="{ name: 'NewCreditNote' }"
            >
              <BIcon
                icon="credit-card-plus"
                type="is-primary"
              />
              <span class="has-text-primary">Nota de Crédito</span>
            </RouterLink>

            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-new-sale-note"
              :to="{ name: 'NewSaleNote' }"
            >
              <BIcon
                icon="file-document-box-outline"
                type="is-primary"
              />
              <span class="has-text-primary">Nota de Remisión</span>
            </RouterLink>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown is-hoverable"
          :class="{ 'is-active': activeMenus.includes('new') }"
        >
          <a
            class="navbar-link is-arrowless link-navbar-catalogs"
          >
            <BIcon
              icon="plus"
              type="is-primary"
            />
            <span class="has-text-primary">Agregar</span>
          </a>

          <div class="navbar-dropdown">
            <a
              class="navbar-item is-flex has-text-white link-navbar-add-customer"
              @click="openModalCustomer"
            >
              <BIcon
                icon="account-group"
                type="is-primary"
              />
              <span class="has-text-primary">
                Cliente
              </span>
            </a>

            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-add-product"
              :to="{ name: 'SkuCatalog' }"
            >
              <BIcon
                icon="barcode"
                type="is-primary"
              />
              <span class="has-text-primary">Producto</span>
            </RouterLink>

            <RouterLink
              class="navbar-item is-flex has-text-white link-navbar-add-employee"
              :to="{ name: 'EmployeePush' }"
            >
              <BIcon
                icon="briefcase-outline"
                type="is-primary"
              />
              <span class="has-text-primary"> Empleado</span>
            </RouterLink>
          </div>
        </div>

        <div
          class="navbar-item has-dropdown is-hoverable"
          :class="{ 'is-active': activeMenus.includes('settings') }"
        >
          <a
            class="navbar-link is-arrowless"
          >
            <BIcon
              icon="settings"
              type="is-primary"
            />
          </a>

          <div class="navbar-dropdown">
            <RouterLink
              class="navbar-item is-flex"
              :to="{ name: 'Company', params: { id: company } }"
            >
              <BIcon
                icon="domain"
                type="is-primary"
              />
              <span class="has-text-primary">Empresa</span>
            </RouterLink>

            <RouterLink
              v-if="canAddRFC"
              class="navbar-item is-flex"
              :to="{ name: 'AddRFC' }"
            >
              <BIcon
                icon="fingerprint"
                type="is-primary"
              />
              <span class="has-text-primary">Agregar RFC</span>
            </RouterLink>

            <template v-if="companies.length > 1">
              <a
                v-for="company in companies.filter(c => c.id !== company)"
                :key="company.id"
                class="navbar-item is-flex"
                @click="changeCompany(company)"
              >
                <BIcon
                  icon="fingerprint"
                  type="is-primary"
                />
                <span class="has-text-primary">{{ company.rfc.rfc }}</span>
              </a>
            </template>

            <RouterLink
              v-if="false"
              class="navbar-item is-flex"
              :to="{ name: 'AddCIEC', params: { id: company } }"
            >
              <BIcon
                icon="archive"
                type="is-primary"
              />
              <span class="has-text-primary">CIEC</span>
            </RouterLink>
          </div>
        </div>

        <span
          v-if="companies.length > 1"
          class="navbar-item is-centered has-text-primary"
        >
          <span class="has-text-primary">{{ $store.state.company.rfc }}</span>
        </span>

        <span class="navbar-item is-flex is-centered">
          <BTooltip
            label="Base de conocimientos"
            position="is-bottom"
            type="is-primary"
          >
            <a
              class="is-flex is-centered"
              :href="knowledgeBaseLink"
              target="__blank"
            >
              <BIcon
                icon="help-circle-outline"
                type="is-primary"
              />
            </a>
          </BTooltip>
        </span>

        <span class="navbar-item is-flex is-centered">
          <RouterLink
            class="button is-danger is-outlined link-sign-out"
            active-class="is-active"
            :to="{ name: 'SignOut' }"
          >
            <BIcon icon="exit-to-app" />
          </RouterLink>
        </span>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

const defaultUrl = 'http://support.facturacionelectronica.izzinegocios.mx/support/home';

const urls = {
  'negociostp.facturatotal.com.mx': 'http://soporte-negociostp.facturatotal.com.mx/support/home',
  'facturatelum.com': 'https://soporte.facturatelum.com',
};

export default {
  name: 'TheNavbar',

  components: {
    AppMenu: () => import(/* webpackChunkName: "app-menu" */ '@/components/Admin/AppMenu.vue'),
  },

  data() {
    return {
      navbarMenu: false,
    };
  },

  computed: {
    ...mapState({
      activeMenus: state => state.ui.activeMenus,
      isTelum: state => state.ui.isTelum,
      company: state => state.company.id,
      rfc: state => state.company.rfc,
      packages: state => state.auth.packages,
      companies: state => state.auth.companies,
    }),
    navbarMenuIsActive() { return { 'is-active': this.navbarMenu }; },
    knowledgeBaseLink() {
      return urls[window.location.host] || defaultUrl;
    },
    canAddRFC() {
      if (!this.packages) return false;
      return this.packages.includes('RFCAdicional') && this.companies.length <= 1;
    },
  },

  watch: {
    $route() {
      this.navbarMenu = false;
    },
  },
  methods: {
    ...mapMutations({
      addActiveMenu: 'ui/addActiveMenu',
      deleteActiveMenu: 'ui/deleteActiveMenu',
      setCompanyValues: 'company/setValues',
      setInvoiceValues: 'invoice/setValues',
      setAuthValue: 'auth/setValue',
    }),
    toggleNavbarMenu() { this.navbarMenu = !this.navbarMenu; },
    changeCompany(c) {
      const { rfc, ...company } = c;

      this.setCompanyValues({
        ...rfc,
        ...company,
        name: rfc.name,
        tradeName: company.name,
      });

      this.setInvoiceValues({
        emitterRegime: rfc.regime,
        emitterName: rfc.name,
        emitterRfc: rfc.rfc,
      });

      this.setAuthValue({ accessor: 'companyId', value: company.id });
    },
    openModalCustomer() {
      this.$modalForm({
        show: true,
        component: 'NewCustomer',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
header.navbar {
  width: 100%;
}

img.logo  {
  height: 48px;
  width: auto;
}

h1 {
  padding-left: .5rem;
}

.navbar.has-shadow {
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, .25);
}

@media screen and (max-width: 768px) {
  .navbar-item {
    display: flex;
    justify-content: flex-end;
  }

  .navbar-brand {
    background: $primary;
  }

  .navbar-menu {
    background: $primary;
  }
}

@media screen and (max-width: 1087px) {
  .navbar-end {
    padding-top: 1rem;
  }
}

@media screen and (min-width: 1088px) {
  .navbar-start {
    display: none;
  }
}
</style>
